function isReadOnly(user) {
  if (!user) return true;
  if (user.tier === "founding_member" || user.tier === "pro") return false;
  if (user.subscription_status === "trialing" || user.subscription_status === "active") return false;
  return true;
}

export { isReadOnly };
